export enum CreateTopologyRoutes {
  DemoImport = '/demo-import',
  DemoType = '/demo-type',
  Details = '/details',
  DemoTemplate = '/demo-template',
}
